
export default {
  name: 'TrainingProgressCircle',
  props: {
    sessions: {
      type: Array,
      default: (): Record<string, unknown>[] => [],
    },
    size: {
      type: Number,
      default: 100,
    },
    strokeWidth: {
      type: Number,
      default: 10,
    },
    percentage: {
      type: Number,
      default: 0,
    },
    customColors: {
      type: Array,
      default: (): Record<string, any> => [
        { color: '#f56c6c', percentage: 20 },
        { color: '#41bbdc', percentage: 40 },
        { color: '#41bbdc', percentage: 60 },
        { color: '#2bc358', percentage: 80 },
        { color: '#2bc358', percentage: 100 },
      ],
    },
    isRenderedInProgressRow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    progress(): number {
      return this.percentage;
    },
    radius(): number {
      return 50 - this.strokeWidth / 2;
    },
    circumference(): number {
      return 2 * Math.PI * this.radius;
    },
    dashOffset(): number {
      return this.circumference * (1 - this.progress / 100);
    },
  },
  methods: {
    getStrokeColor(percentage: number): string {
      const matchingColor = this.customColors.find((color) => percentage <= color.percentage);
      return matchingColor ? matchingColor.color : '';
    },
  },
};
